import ZoomVideo from "@zoom/videosdk";
import { createContext, ReactNode, useEffect, useState } from "react";
import { ZoomClient } from "./index-types";

export const ZoomContext = createContext<ZoomClient | null>(null);

export const ZoomClientProvider = ({ children }: { children: ReactNode }) => {
  const [zmClient, setZmClient] = useState<ZoomClient | null>(null);

  useEffect(() => {
    const initializeZoomClient = async () => {
      const client = ZoomVideo.createClient();
      await client.init("en-US", "CDN", {
        stayAwake: true,
        patchJsMedia: true,
        leaveOnPageUnload: false,
        enforceVirtualBackground: true,
      });

      setZmClient(client); // Set the initialized client to state
    };

    initializeZoomClient();

    // Cleanup function to destroy the client on unmount
    return () => {
      zmClient?.leave();
      ZoomVideo.destroyClient();
    };
  }, []);

  return (
    <ZoomContext.Provider value={zmClient}>{children}</ZoomContext.Provider>
  );
};
